import { object, string } from "yup";
import User from "../../interfaces/user.interface";

export const userProfileSchema = object({
  email: string().email().required(),
  contactEmail: string().email().required(),
  phone: string().required(),
  title: string().required(),
  designation: string().required(),
  lastName: string().required(),
  firstName: string().required(),
  member: string().required(),
  membership: string(),
  country: string().required(),
  province: string().required(),
  city: string().required(),
  address: string().required(),
  aptSuite: string(),
  zipCode: string().required(),
});

export const userProfileValues = (user: User) => {
  return {
    email: user?.email || "",
    contactEmail: user?.contactEmail || "",
    phone: user?.phone || "",
    title: user?.title || "mr",
    designation: user?.designation || "",
    lastName: user?.lastName || "",
    firstName: user?.firstName || "",
    member: user?.member || "",
    membership: user?.membership || "",
    country: user?.country || "",
    province: user?.province || "",
    city: user?.city || "",
    address: user?.address || "",
    aptSuite: user?.aptSuite || "",
    zipCode: user?.zipCode || "",
  };
};

export const loginInformationSchema = object({
  email: string().email().required(),
  lastName: string().required(),
  firstName: string().required(),
  currentPwd: string(),
  newPwd: string(),
  confirmPwd: string(),
});

export const loginInformationValues = (user: User) => {
  return {
    email: user?.email ?? "",
    lastName: user?.lastName ?? "",
    firstName: user?.firstName ?? "",
    currentPwd: "",
    newPwd: "",
    confirmPwd: "",
  };
};

export const profileObj = (user: User, form: any) => {
  return {
    id: user!.id,
    association: user?.association ?? "",
    address: form?.address ?? "",
    aptSuite: form!.aptSuite ?? "",
    city: form?.city ?? "",
    contactEmail: form?.contactEmail ?? "",
    country: form?.country ?? "",
    createdAt: user!.createdAt ?? "",
    designation: form.designation ?? "",
    email: user!.email ?? "",
    firstName: form?.firstName ?? "",
    lastName: form?.lastName ?? "",
    member: form?.member ?? "",
    membership: form?.membership ?? "",
    mobile: user!.mobile ?? "",
    notes: user!.notes ?? "",
    phone: form?.phone ?? "",
    zipCode: form?.zipCode ?? "",
    province: form?.province ?? "",
    role: user!.role ?? "",
    status: "1",
    title: form?.title ?? "",
    profilePicture: user!.profilePicture ?? "",
    institutionId: user!.institutionId ?? "",
    educations: user!.educations ?? "",
  };
};
